/* eslint-disable no-nested-ternary */
import { Countries } from '@constants/enums';
import fundingSvc from '@efex-services/funds/fundingSvc';
import useImmediateApiCall from '@main-hooks/useImmediateApiCall';
import { Alert, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useApiCall } from 'use-api-call';
import { getCurrencyByCountry } from '@utils/currencyHelpers';
import { Button, DialogActions } from '@efexteam/components';
import { logoEfex } from '../../../../assets';
import {
  selectBusiness,
  selectProfileData,
} from '../../../../pages/profile/store/selectors';
import FundsInstructionsUSA from '../../addfundstep/FundsInstructionsUSA';
import DetailView from '../components/DetailView';
import PAYMENT_STEPS from '../constants';
import { useFormData } from '../context';

interface BankProps {
  nextFormStep: () => void;
  prevFormStep: (value: number) => void;
}

const Bank = ({ nextFormStep, prevFormStep }: BankProps) => {
  const { t } = useTranslation();
  const company = useSelector(selectBusiness);
  const userProfile = useSelector(selectProfileData);
  const { data } = useFormData();

  const { client: clientSelected, currency } = data;

  const { isAwActive } = userProfile || {};
  const { bankAccount } = userProfile || {};

  const profileCurrency = getCurrencyByCountry({
    countryCode: bankAccount?.currency as Countries,
  });

  const { data: fundsInstructions } = useImmediateApiCall(() =>
    fundingSvc.addFundsUsaInstructions({
      enterpriseId: company?.enterpriseId || '0',
      currency: currency ?? profileCurrency,
    })
  );

  const {
    loading,
    data: UsaInstructions,
    invoke: addFundsUsaInstructions,
  } = useApiCall(() =>
    fundingSvc.addFundsUsaInstructions({
      enterpriseId: company?.enterpriseId || '0',
      currency: currency ?? profileCurrency,
    })
  );

  const COMPANY_INSTRUCTIONS = {
    MX: (
      <FundsInstructionsUSA
        newInstructions={UsaInstructions}
        currency={data.currency}
      />
    ),
    USA: (
      <FundsInstructionsUSA
        loading={loading}
        instructions={fundsInstructions as any}
        newInstructions={UsaInstructions}
        currency={data.currency}
      />
    ),
    COL: (
      <FundsInstructionsUSA
        newInstructions={UsaInstructions}
        currency={data.currency}
      />
    ),
  };

  useEffect(() => {
    addFundsUsaInstructions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAwActive]);

  if (!clientSelected) return null;

  return (
    <Grid container className="relative">
      <Grid item xs={12}>
        <div className="modal-body text-center m-auto w-full w-100">
          <Typography className="!text-lg !my-2">
            {t('paymentMethods')}:{' '}
          </Typography>
          <img src={logoEfex} alt="logo_ventu" className="logo_ventu !mb-3" />

          <Alert severity="warning" className="!mb-2">
            {t('bankDepositMessage')}
          </Alert>

          <DetailView spacing="compact" />

          <div className="instructions">
            <Typography className="instructions__title">
              {t('titleInstructionsMP')}
            </Typography>
            <div className="instructions__points">
              {
                COMPANY_INSTRUCTIONS[
                  isAwActive ? Countries.USA : company?.country ?? 'USA'
                ]
              }
            </div>
          </div>
        </div>
      </Grid>
      <DialogActions className="flex justify-between !flex-col md:!flex-row w-full sticky -bottom-8 bg-white gap-4 !pt-4">
        <Button
          appearance="secondary"
          size="large"
          className="mt-4"
          onClick={() => prevFormStep(PAYMENT_STEPS.PAYMENT_METHOD)}
        >
          {t('back')}
        </Button>
        <Button
          appearance="primary"
          size="large"
          className="mt-4"
          onClick={nextFormStep}
        >
          {t('confirmPayment')}
        </Button>
      </DialogActions>
    </Grid>
  );
};

export default Bank;
